module.exports = __webpack_public_path__ + "static/img/info-bg01.ec575f3c.png";